import type { JSX, PropsWithChildren } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

export function ColumnSection({ children }: PropsWithChildren<EmptyProps>): JSX.Element {
	return (
		<Box as="section" mb={32}>
			{children}
		</Box>
	);
}
